import React, { Component } from "react";
class WidgetsWrapper extends Component {
  state = {};
  render() {
    const { identifier, wrapperClasses, children } = this.props;
    return (
      <div id={identifier} key={identifier} className={wrapperClasses}>
        {children}
      </div>
    );
  }
}

export default WidgetsWrapper;
